export default {
  desktop: 'Рабочий стол',
  users: 'Cотрудники',
  passportization: 'Цифровой двойник',
  alertManager: 'Уведомления',
  alarms: 'Инциденты',
  individualControl: 'Контроль',
  groupControl: 'Групповой контроль',
  scheduleManager: 'Управление расписаниями',
  objectsGroups: 'Управление группами',
  installation: 'Установка и подключения',
  reportManager: 'Управление отчетами',
  energyConsumption: 'Энергопотребление',
  life: 'Контроль износа и планирование ремонта',
  objects: 'Центр контроля',
  analyticsAlarms: 'Аналитика неисправностей',
  searchWidget: 'Поиск по системе',
  controlCenter: 'Центр управления',
  equipmentReference: 'Справочники',
  operationAndTechnicalSupport: 'Служба поддержки',
  settings: 'Настройки системы',
  changeLog: 'Журнал изменений',
  foldMenu: 'Свернуть описание',
  menuTitle: 'Меню навигации',
  inventory: 'Инвентаризация и учет',
  lightingObjects: 'Объекты освещения',
  analyticExpenses: 'Ресурсы и эффективность',
  activityLog: 'Контроль действий',
  ppr: 'ППР',
  pprMenuSidbar: 'Проведение контрольно-плановых мероприятий',
  activitiLogMenuSidebar: 'Контроль действий',
  advancedSearch: 'Поиск по системе',
  carElectricStations: 'Зарядные автостанции',
  waterSupply: 'Водоснабжение',
  heatSupply: 'Теплоснабжение',
  smartRecycleBin: 'Контроль наполняемости мусорных баков',
  controlObject: 'Oбъекты контроля',
  mainScreenSettings: 'Настройки главного экрана',
  upperBlock: 'Верхний блок',
  mainApps: 'Основные приложения',
  dragMessage: 'Меняйте элементы местами, перетаскивая их за иконку справа. \nЭлементы можно добавлять или убирать с экрана, нажав на иконку слева.',
  usedElements: 'Используемые элементы',
  unusedElements: 'Неиспользуемые элементы',
  activateMessage: 'Для активации недоступных элементов обратитесь к администратору вашей организации',
  pin: 'Закрепить',
  unpin: 'Открепить',
  pinNode: 'Закрепить объект',
  pinNodeMessage: 'Это действие закрепит данный объект и открепит ранее закреплённый.',
  emptyPinNode: 'Нет закрепленных объектов',
  unpinNode: 'Открепить объект',
  unpinNodeMessage: 'Это действие снимет закрепление данного объекта.',
  statuses: {
    new: 'Новые',
    old: 'Просмотренные',
    all: 'Все статусы',
  },
  statusesPpr: {
    new: 'Не просрочен',
    old: 'Просрочен',
  },
  communicationStatus: 'Состояние связи',
  on: 'Вкл.',
  onLong: 'Включен',
  off: 'Выкл.',
  offLong: 'Выключен',
  online: 'На связи',
  offline: 'Не на связи',
  refreshed: 'Обновлено',
  unknown: 'Неизвестно',
  height: 'Высота',
  builtInRelay: 'Встроенное реле',
  driver: 'Драйвер 1-10',
  driverDali: 'Драйвер по протоколу DALI',
  min: 'Мин',
  max: ' Макс',
  working: 'Работает',
  notWorking: 'Не работает',
  onPhase: 'на фазе',
  globalPopup: {
    accept: 'Принять',
    save: 'Сохранить',
    cancel: 'Отмена',
    verify: 'Верифицировать',
    yes: 'да',
    no: 'нет',
  },
  selected: 'Выбрано',
  multipleSelected: 'Выбрано несколько',
  multipleSelectedMessage: 'Нельзя выбрать больше 20 значений в фильтре',
  multipleSelectedMessageGroupObjects: 'Нельзя выбрать больше 30 значений в фильтре',
  onlineUser: 'Онлайн',
  getMore: 'Загрузить еще'
}
